// extracted by mini-css-extract-plugin
module.exports = {"container":"PageHeader_container__3U5dA","content":"PageHeader_content__q2PLh","photographer":"PageHeader_photographer__3F9c-"};